import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ImageVideoGallerySlide } from '@/common/interfaces/modules/ImageVideoGallery';
import FacebookIcon from '@/assets/icons/facebook.svg?inline';
import TwitterIcon from '@/assets/icons/twitter.svg?inline';
import EmailIcon from '@/assets/icons/email-filled.svg?inline';
import { ShareViewModel } from '@/components/Share/Share.types';

Vue.component('FacebookIcon', FacebookIcon);
Vue.component('TwitterIcon', TwitterIcon);
Vue.component('EmailIcon', EmailIcon);

@Component({
  components: {},
})
export default class PhotoInfo extends Vue {
  @Prop({ type: Object as () => ImageVideoGallerySlide, default: () => {} })
  slide!: ImageVideoGallerySlide;

  @Prop({ type: Object as () => ShareViewModel, default: () => {} })
  shareData!: ImageVideoGallerySlide;

  @Prop({ type: Number })
  swiperCurrentIndex!: number;

  @Prop({ type: Boolean, default: false })
  showingPhotoInfo!: boolean;
}
